import { Theme } from "@material-ui/core";

export function percentColour(percent: number, theme: Theme): string {
  return percent >= 75
    ? theme.palette.success.main
    : percent >= 50
    ? theme.palette.primary.main
    : theme.palette.error.main;
}
